export enum GoogleLogEvents {
    screenView = 'screen_view',
    exception = 'exception',
    purchase = 'purchase',
    bannerClick = 'banner_click'
}

export enum LoggerStrategies {
    GOOGLE = 'GoogleStrategy',
}
